import {ReactElement, ReactNode} from 'react';

import {AppContextProvider} from '~/components';

interface Props {
  children?: ReactNode;
}

/**
 * For some reason this wrapper ensures that app context always runs using the correct context passed from app context provider
 * without it, it will sometimes take the initial context, probably something to do with RSC
 * So in summary, don't remove this component
 */
export function AppContextProviderWrapper({children}: Props): ReactElement {
  return <AppContextProvider>{children}</AppContextProvider>;
}
